import { render, staticRenderFns } from "./TipSetting.vue?vue&type=template&id=adea3cc6"
import script from "./TipSetting.vue?vue&type=script&lang=js"
export * from "./TipSetting.vue?vue&type=script&lang=js"
import style0 from "./TipSetting.vue?vue&type=style&index=0&id=adea3cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports